module.exports = __webpack_public_path__ + "static/img/knowleage-banner-new.6ec17aba.png";